import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { AccordianComponent } from "../accordian.component";
import "./accordian-entry.component.scss";

@Component({
    selector: "accordian-entry",
    template: require("./accordian-entry.component.html"),
})
export class AccordianEntryComponent  {
    @Input() title: string = "Title Required";
    @Input() open = false;
    @Input() icon: string;

    // ---

    constructor(
        private readonly accordian: AccordianComponent
    ) {
        accordian.registerAccordianEntry(this);
    }

    toggle(): void {
        this.open = !this.open;
    }

    close(): void {
        this.open = false;
    }

    // ---

}
